import React from 'react';
import { inject, observer } from 'mobx-react';

const DevLinkOffer = ({ item, user, app }) => {
  const show = app.features && app.features.offerLinks;
  if (!show) {
    return <span />;
  }
  const { protocol, host } = window.location;
  const path = `${
    item.buyer.buyer_locale ? item.buyer.buyer_locale + '/' : ''
  }${item.saleId}?sub=${item.buyerId}`;

  const tenant = process.env.REACT_APP_TENANT.startsWith('propnow')
    ? user.claims.tenant || process.env.REACT_APP_TENANT
    : process.env.REACT_APP_TENANT;

  const url = `${protocol}//${host.replace(/^app/, tenant)}/${path}`;

  // console.log('test', url);

  const { Link } = require('office-ui-fabric-react/lib/Link');
  const { Icon } = require('office-ui-fabric-react/lib/Icon');
  return (
    <Link
      href={url}
      target="_blank"
      data-test-id="buyer-link"
      data-test-value={item.buyer.buyer_email}
    >
      <Icon iconName="FieldNotChanged" />
    </Link>
  );
};

export default inject('user', 'app')(observer(DevLinkOffer));



// WEBPACK FOOTER //
// ./src/app/containers/Sale/OffersSection/DevLinkOffer.jsx